
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IHainanInvoiceAdd, IHainanInvoiceItem, IHainanInvoiceTree } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 系统配置 - 海南开票科目列表
 */
export async function queryHainanInvoiceList(enable: 0 | 1 = 0, noParent: boolean = true) {
  let data = [] as IHainanInvoiceItem[];

  try {
    const { code, context, message } = await Http.post<IHainanInvoiceItem[]>(`${hostUrl}/side/hn/InvoiceSub/list`, {
      enable,
      noParent,
    });

    if (code === EAxiosResponseCode.Succeed) {
      const items = context || [] as IHainanInvoiceItem[];
   
      data = items || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
   
  return data;
}

/**
 * 系统配置 - 海南开票科目启用状态
 */
export async function updateHainanInvoiceEnable(id: number) {

  try {
    const { code, message } = await Http.post<{ data: IHainanInvoiceItem[]; total: number }>(`${hostUrl}/side/hn/InvoiceSub/enable`, { id });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 获取开票科目树状列表
 * @param params 查询参数
 */
export async function queryHainanInvoiceTree() {
  try {
    const { code, context, message } = await Http.post<IHainanInvoiceTree[]>(`${hostUrl}/side/hn/InvoiceSub/listTree`);

    if (code === EAxiosResponseCode.Succeed) {
      return context || [];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 获取海南开票科目树状列表 - 创建任务
 * @param params 查询参数
 */
export async function queryHainanForCreateTask(industryId: number, productId: number) {
  try {
    const { code, context, message } = await Http.post<IHainanInvoiceTree[]>(`${hostUrl}/side/hn/InvoiceSub/listTreeForIndustry`, {
      industryId,
      productId, 
    });

    if (code === EAxiosResponseCode.Succeed) {
      return context || [];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 海南开票科目库 - 新增
 * @param params 查询参数
 */
export async function addHainanInvoiceTree(params: IHainanInvoiceAdd) {
  try {
    const { code, context, message } = await Http.post(`${hostUrl}/side/hn/InvoiceSub/add`, params);

    if (code === EAxiosResponseCode.Succeed) {
      return context || [];
    }
    throw new Error(message || '服务器异常，请稍后再试~');
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 海南开票科目库 - 编辑
 */
export async function updateHainanInvoiceEdit(params: IHainanInvoiceAdd) {

  try {
    const { code, message } = await Http.post(`${hostUrl}/side/hn/InvoiceSub/edit`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 海南开票科目库 - 删除二级科目
 */
export async function deleteHainanInvoiceSecond(id: number) {

  try {
    const { code, message } = await Http.post(`${hostUrl}/side/hn/InvoiceSub/del`, { id });

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}